module.exports = __webpack_public_path__ + "static/stacked-area-2fde845c90571cfaa69b1460bfadeb3c.png";